/* Dave's Drum Shop: persist signature delivery preference on Shopify cart. */
(function () {
  var key = 'Delivery Signature Preference';
  document.addEventListener('change', function(event) {
    var input = event.target;
    if (!input.matches || !input.matches('input[name="attributes[Delivery Signature Preference]"]')) return;
    var choice = input.value;
    document.querySelectorAll('input[name="attributes[Delivery Signature Preference]"]').forEach(function(other) { other.checked = other.value === choice; });
    var group = input.closest('.dds-signature-preference');
    var status = group && group.querySelector('.dds-signature-status');
    if(status) { status.style.display='block'; status.textContent='Saving preference…'; }
    fetch((window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'cart/update.js', {
      method:'POST', headers:{'Content-Type':'application/json'},
      body:JSON.stringify({attributes:{[key]:choice}})
    }).then(function(response) {if(!response.ok) throw new Error('Could not save');return response.json();})
      .then(function(){if(status) status.textContent='Delivery preference saved.';})
      .catch(function(){if(status) status.textContent='Could not save preference. Please retry or proceed from the cart page.';});
  });
})();
